export default "__VITE_ASSET__K1wR6Nu9__"